// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"13e77143","271":"7e5158db","443":"c02e69a8","540":"84ae29a4","630":"9738ef2a","989":"28c998b7"}[chunkId] + ".chunk.js";
};